import { Box, Checkbox, Typography, IconButton, alpha } from '@mui/material';
import { Delete } from '@mui/icons-material';
import type { SubTask } from '@/types/todolist';
import { brandColors } from '@/theme/colors';

type SubtaskRowProps = {
  subtask: SubTask;
  canEdit: boolean;
  onToggle: () => void;
  onDelete: () => void;
};

export const SubtaskRow = ({
  subtask,
  canEdit,
  onToggle,
  onDelete,
}: SubtaskRowProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      py: 0.5,
      pl: 1,
      borderRadius: 1,
      '&:hover': { bgcolor: alpha(brandColors.purple, 0.05) },
    }}
  >
    <Checkbox
      checked={subtask.completed}
      onChange={onToggle}
      disabled={!canEdit}
      size="small"
      sx={{
        p: 0.5,
        color: brandColors.purple,
        '&.Mui-checked': { color: brandColors.accent.green },
      }}
    />
    <Typography
      variant="body2"
      sx={{
        flexGrow: 1,
        textDecoration: subtask.completed ? 'line-through' : 'none',
        color: subtask.completed ? 'text.disabled' : 'text.primary',
      }}
    >
      {subtask.title}
    </Typography>
    {canEdit && (
      <IconButton
        size="small"
        onClick={onDelete}
        sx={{
          opacity: 0.5,
          '&:hover': { opacity: 1, color: brandColors.accent.red },
        }}
      >
        <Delete sx={{ fontSize: 16 }} />
      </IconButton>
    )}
  </Box>
);
